<script lang="ts">
	import {uqn} from './stores.js';
	import check from './check_random/check';
	import random from './check_random/random';
	import Textfield, {Input, Textarea} from '@smui/textfield';
	import Button, {Label, Icon} from '@smui/button';
	import Dialog, {Title, Content, Actions} from '@smui/dialog';
	import Slider from '@smui/slider';
	import FormField from '@smui/form-field';
	import Katex from './Katex.svelte';
	import Radio from '@smui/radio';
	import getRandomInt from './functions/getRandomInt';
	import uqnSplit from './functions/uqnSplit';
	import uqnJoin from './functions/uqnJoin';
	import AnswerPreview from './AnswerPreview.svelte';
	import Fraction from './functions/fractionClass';

	let uqnInput: number;
	let simpleDialog;
	
	let aSlide: number, a: number, bSlide: number, b: number;
	let rSlide: number, rString: string;
	let cSlide: number, c: number, dSlide: number, d: number;
	let aSlide2: number, bSlide2: number;
	let sign: number;
	let _;

	// initialize
	let firstRadio = Math.ceil(Number($uqn.toString()[0])/2).toString();
	let type = $uqn.toString()[0];
	$: _ = updateFromFirstRadio(firstRadio);
	$: _ = updateFromType(type);
	$: _ = updateFromUQN($uqn);
	$: _ = updateType12Slider(type,aSlide,bSlide,rSlide);
	$: _ = updateType36Slider(type,aSlide2,bSlide2,cSlide,dSlide,sign);
	//$: _ = updateType56Slider(type,aSlide2,bSlide2,cSlide,dSlide,sign);

	function updateFromFirstRadio(r:string){
		if (r != Math.ceil(Number($uqn.toString()[0])/2).toString()){
			let t = (Number(r)*2-getRandomInt(0,1)).toString();
			uqnInput = random(Number(t));
			uqn.set(uqnInput);
			type = t;
		}
	};

	function updateFromType(t:string){
		if (t!=$uqn.toString()[0]){
			if (t=="1"||t=="2"){
				let [_,x1,y1,x2,sign] = uqnSplit($uqn);
				uqnInput = uqnJoin([t,x1,y1,x2,sign]);
			} else{
				let [_,x1,y1,x2,y2,sign] = uqnSplit($uqn);
				if (t=="3" && sign > 3){
					sign = getRandomInt(0,3);
				} else if (t=="4"){
					if (x2==0){
						x2 = getRandomInt(1,9);
					}
					if (sign > 7){
						sign = getRandomInt(0,7);
					}
				}
				uqnInput = uqnJoin([t,x1,y1,x2,y2,sign]);
			}	
			uqn.set(uqnInput);
		}
	}
	
	function updateFromUQN(u:number){
		uqnInput = u;
		type = u.toString()[0];
		firstRadio = Math.ceil(Number(type)/2).toString();
		if (type=="1"||type=="2"){
			let [_,x,y,r,s] = uqnSplit(u);
			let denom = 1;
			if (s>3){
				denom = 2; r = r*2-1;
			}
			const xrSign = s%4;
			if (xrSign%2==1){
				r *= -1;
			}
			if (xrSign>1){
				x *= -1;
			}
			rSlide = (denom==1)?r*2:r;
			aSlide = x;
			bSlide = y;
			rString = new Fraction(r,denom).toString();
		} else if (type=="5"||type=="6"){
			let [_,x1,y1,x2,y2,s] = uqnSplit(u);
			aSlide2 = x1; bSlide2 = y1; cSlide = x2; dSlide = y2;
			sign = s;
			switch (sign){
				case 1:
					y2 *= -1;
					break
				case 2:
					x2 *= -1;
					break
				case 3:
					y1 *= -1;
					break
				case 4:
					x1 *= -1;
					break
				case 5:
					y2 *= -1; y1 *= -1;
					break
				case 6:
					y1 *= -1; x2 *= -1;
					break
				case 7:
					x2 *= -1; x1 *= -1;
					break
				case 8:
					x1 *= -1; y2 *= -1;
					break
				case 9:
					y2 *= -1; x2 *= -1; y1 *= -1;
					break
			}
			a = x1; b=y1; c=x2; d=y2;
		} else if (type=="3"|| type=="4") {
			let [_,x1,y1,x2,y2,s] = uqnSplit(u);
			aSlide2 = x1; bSlide2 = y1; cSlide = x2; dSlide = y2;
			sign = s;
			const xrSign = sign%4;
			if (xrSign%2==1){
				x2 *= -1;
			}
			if (xrSign>1){
				x1 *= -1;
			}
			if (sign > 3){
				y2 *= -1;
			}
			a = x1; b=y1; c=x2; d=y2;
		}
	}

	function updateType12Slider(t:string,x:number,y:number,r:number){
		if (t=="1"||t=="2"){
			if (r==0){
				let sign2: number;
				[_,_,_,_,sign2] = uqnSplit($uqn);
				if (sign2%2==1){
					r=-1;
					rSlide = r;
				} else{
					r=1;
					rSlide=r;
				}
			}
			rString = new Fraction(r,2).toString();
			// recreate sign
			let sign3: number;
			if (x>=0 && r>0){
				sign3=0;
			} else if (x>=0 && r<0){
				sign3=1;
			} else if (x<0 && r > 0){
				sign3=2;
			} else{
				sign3=3;
			}
			r = Math.abs(r);
			if (r%2==1){ 
				sign3 += 4;
				r = (r+1)/2;
			} else{
				r = r/2;
			}
			sign = sign3;
			uqnInput = uqnJoin([t,Math.abs(x),y,Math.abs(r),sign]);
			uqn.set(uqnInput);
		}
	}

	function updateType36Slider(t:string,x1:number,y1:number,x2:number,y2:number,s:number){
		if (type=="3"||type=="4"||type=="5"||type=="6"){
			if (t=="4"&&x2==0){
				x2=1;
				cSlide=1;
			} else{
				cSlide = x2;
			}
			a=x1; b=y1; c=x2; d=y2;		
			if (t=="3"||t=="4"){
				const xrSign = s%4;
				if (xrSign%2==1){
					c *= -1;
				}
				if (xrSign>1){
					a *= -1;
				}
				if (sign > 3){
					d *= -1;
				}
			} else{
				switch (s){
					case 1:
						d *= -1;
						break
					case 2:
						c *= -1;
						break
					case 3:
						b *= -1;
						break
					case 4:
						a *= -1;
						break
					case 5:
						d *= -1; b *= -1;
						break
					case 6:
						b *= -1; c *= -1;
						break
					case 7:
						c *= -1; a *= -1;
						break
					case 8:
						a *= -1; d *= -1;
						break
					case 9:
						d *= -1; c *= -1; b *= -1;
						break
				}
			}
			uqnInput = uqnJoin([t,x1,y1,x2,y2,s]);
			uqn.set(uqnInput);
		}
	}

	function uqnClick(){
		if (check(uqnInput)){
			uqn.set(uqnInput)
		} else{
			simpleDialog.open();
		}
	}	

</script>

<h2>Options</h2>
<hr>
<h3>UQN</h3>
<p>
	Retrieve a question by keying in a UQN (5-6 digits):
</p>
<Textfield class="shaped-outlined" variant="outlined" bind:value={uqnInput} label="UQN" type="number"/>
<Button on:click={uqnClick} variant="unelevated" class="button-shaped-round">
	<Label>Generate question</Label>
</Button>
<hr>
<h3>
	Question construction tools
</h3>
<hr>
<div>
	<p>First choose the general type of question:</p>
	<FormField>
		<Radio bind:group={firstRadio} value=1/>
		<span slot="label">Cubic equation</span>
	</FormField>
	<FormField>
		<Radio bind:group={firstRadio} value=2/>
	<span slot="label">Quartic equation</span>
	</FormField>
	<FormField>
		<Radio bind:group={firstRadio} value=3/>
		<span slot="label">Quadratic equation with complex coefficients</span>
	</FormField>
</div>
<hr>
<p>Next choose the variant of the question:</p>
{#if firstRadio=="1"}
	<FormField>
		<Radio bind:group={type} value=1/>
		<span slot="label">Known coefficients</span>
	</FormField>
	<FormField>
		<Radio bind:group={type} value=2/>
	<span slot="label">Unknown coefficients</span>
	</FormField>
{:else if firstRadio=="2"}
	<FormField>
		<Radio bind:group={type} value=3/>
		<span slot="label">4 complex roots</span>
	</FormField>
	<FormField>
		<Radio bind:group={type} value=4/>
	<span slot="label">2 complex roots, 2 real roots</span>
	</FormField>
{:else if firstRadio=="3"}
	<FormField>
		<Radio bind:group={type} value=5/>
		<span slot="label">Leading coefficient of 1</span>
	</FormField>
	<FormField>
		<Radio bind:group={type} value=6/>
	<span slot="label">Leading coefficient of <Katex math={"i"}/></span>
	</FormField>
{/if}
<hr>
<p> 
	This question is generated from the roots of the equation.
</p>
<p>
	Our roots are of the form
	{#if type=="1" || type=="2"}
		<Katex math="z=a \pm bi, z=c"/>
	{:else if type=="3"}
		<Katex math="z=a \pm bi, z=c \pm di"/>
	{:else if type=="4"}
		<Katex math="z=a \pm bi, z=c, z=d"/>
	{:else}
		<Katex math="z=a+bi, z=c+di"/>
	{/if}.
</p>
<AnswerPreview uqn={$uqn}/>
<hr>
<p>
	Use the sliders belows to choose different options to craft your own unique question.
</p>
{#if type=="1"||type=="2"}
<div>
	<FormField align="end" style="display: flex; width: 90%" >
		<Slider bind:value={aSlide} min={-9} max={9} step={1} style="width:80%" discrete displayMarkers/>
		<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={"a="+aSlide.toString()}/></span>
	</FormField>
	<FormField align="end" style="display: flex; width: 90%" >
		<Slider bind:value={bSlide} min={1} max={9} step={1} style="width:80%" discrete displayMarkers/>
		<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={"b="+bSlide.toString()}/></span>
</FormField>
</div>
{:else}
<div>
	<FormField align="end" style="display: flex; width: 90%" >
		<Slider bind:value={aSlide2} min={0} max={9} step={1} style="width:80%" discrete displayMarkers/>
		<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={"a="+a.toString()}/></span>
	</FormField>
	<FormField align="end" style="display: flex; width: 90%" >
		<Slider bind:value={bSlide2} min={1} max={9} step={1} style="width:80%" discrete displayMarkers/>
		<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={"b="+b.toString()}/></span>
	</FormField>
	<FormField align="end" style="display: flex; width: 90%" >
		<Slider bind:value={cSlide} min={0} max={9} step={1} style="width:80%" discrete displayMarkers/>
		<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={"c="+c.toString()}/></span>
	</FormField>
	<FormField align="end" style="display: flex; width: 90%" >
		<Slider bind:value={dSlide} min={1} max={9} step={1} style="width:80%" discrete displayMarkers/>
		<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={"d="+d.toString()}/></span>
	</FormField>
</div>
{/if}
{#if type=="1"||type=="2"}
	<FormField align="end" style="display: flex; width: 90%" >
		<Slider bind:value={rSlide} min={-18} max={18} step={1} style="width:80%" displayMarkers/>
		<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={"c="+rString}/></span>
	</FormField>
{:else if type=="5"||type=="6"||type=="4"}
	<p>The last slider modifies the signs of some of the constants above.</p>
	<FormField align="end" style="display: flex; width: 90%" >
		<Slider bind:value={sign} min={0} max={9} step={1} style="width:80%" displayMarkers/>
		<span slot="label" style="padding-right: 12px; width: max-content; display: block;"></span>
	</FormField>
{:else if type=="3"}
	<p>The last slider modifies the signs of some of the constants above.</p>
	<FormField align="end" style="display: flex; width: 90%" >
		<Slider bind:value={sign} min={0} max={3} step={1} style="width:80%" displayMarkers/>
		<span slot="label" style="padding-right: 12px; width: max-content; display: block;"></span>
	</FormField>
{/if}


<Dialog bind:this={simpleDialog}>
	<!-- Title cannot contain leading whitespace due to mdc-typography-baseline-top() -->
	<Title>Invalid UQN</Title>
	<Content>
		You have keyed an invalid UQN. Please try again.
	</Content>
	<Actions>
		<Button>
			<Label>OK</Label>
		</Button>
	</Actions>
</Dialog>
<hr>